import { Box } from '@razorpay/blade/components';
import { routePaths } from 'components/Routes/data';
import { WizardHeader, WizardWrapper } from 'components/WizardViews/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import React from 'react';
import { useHistory } from 'react-router-dom';
import GeneralDetailsStep from './GeneralDetailsStep';

const CreateNonPayableBenefitsForm = () => {
  const currentStep = 1;

  const history = useHistory();

  const handleCloseClick = () => {
    history.push(routePaths.salaryComponents.root);
  };

  return (
    <WizardInfoProvider initialStep={currentStep} totalSteps={1}>
      <WizardWrapper>
        <WizardHeader
          heading="New"
          subHeading="Non-Payable Benefits Component"
          onCloseClick={handleCloseClick}
        />
        <Box flex={1} overflowY="auto" height="100%">
          <GeneralDetailsStep />
        </Box>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};

export default CreateNonPayableBenefitsForm;
